var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
        },
        on: {
          afterFetchOriginalData: _vm.getLowTableData,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseCostDown.Assessment"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseCostDown.Assessment"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_month,
                            callback: function ($$v) {
                              _vm.queryParamsTime_month = $$v
                            },
                            expression: "queryParamsTime_month",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: _vm.colSpan } }, [
                  _c("div", { staticStyle: { width: "30px", height: "10px" } }),
                ]),
                _c("el-col", { attrs: { span: _vm.colSpan } }, [
                  _c("div", { staticStyle: { width: "30px", height: "10px" } }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjFrontendExport", {
                      attrs: {
                        type: "primary",
                        "label-list": _vm.labelList,
                        rows: _vm.selectedRows,
                        "file-name": "Timeliness rate of return orders.csv",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExportDetail },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessPurchaseCostDown.exportDetail")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "sku"
                                      ? [
                                          _c("span", { staticClass: "link" }, [
                                            _vm._v(_vm._s(scope.row[col.prop])),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "returnTimelyRateA"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row[col.prop] * 100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "returnTimelyRateB"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row[col.prop] * 100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "returnTimelyRateErpA"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row[col.prop] * 100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "returnTimelyRateErpB"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row[col.prop] * 100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "returnTimelyRate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row[col.prop] * 100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "TimelinessERP"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  ((scope.row.levelAErpEndQty +
                                                    scope.row.levelBErpEndQty) /
                                                    (scope.row.levelAQty +
                                                      scope.row.levelBQty)) *
                                                  100
                                                ).toFixed(2) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isCost"
                                      ? _c("el-switch", {
                                          attrs: {
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.switchButton(
                                                $event,
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row[col.prop],
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, col.prop, $$v)
                                            },
                                            expression: "scope.row[col.prop]",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }